import React from "react";
import ParkingPass from "./parkingpass";
import { withBottombar } from "../../HOCs";
class ParkingPassParent extends React.Component {
  render() {
    return <ParkingPass {...this?.props} />;
  }
}

const props = {
  top_bar: "title_bar",
}

export default withBottombar(ParkingPassParent, props);
